
 const PersonWithCheckIcon = ()=>(
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#clip0_2416_274)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.976372 10.3096C1.60149 9.68444 2.44934 9.33325 3.33339 9.33325H8.00006C8.88412 9.33325 9.73196 9.68444 10.3571 10.3096C10.9822 10.9347 11.3334 11.7825 11.3334 12.6666V13.9999C11.3334 14.3681 11.0349 14.6666 10.6667 14.6666C10.2985 14.6666 10.0001 14.3681 10.0001 13.9999V12.6666C10.0001 12.1362 9.78935 11.6274 9.41427 11.2524C9.0392 10.8773 8.53049 10.6666 8.00006 10.6666H3.33339C2.80296 10.6666 2.29425 10.8773 1.91918 11.2524C1.54411 11.6274 1.33339 12.1362 1.33339 12.6666V13.9999C1.33339 14.3681 1.03492 14.6666 0.666728 14.6666C0.298538 14.6666 6.10352e-05 14.3681 6.10352e-05 13.9999V12.6666C6.10352e-05 11.7825 0.351251 10.9347 0.976372 10.3096Z"
                fill="#5E1E5C"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.8048 5.52851C16.0651 5.78886 16.0651 6.21097 15.8048 6.47132L13.1381 9.13799C12.8778 9.39834 12.4557 9.39834 12.1953 9.13799L10.862 7.80466C10.6016 7.54431 10.6016 7.1222 10.862 6.86185C11.1223 6.6015 11.5444 6.6015 11.8048 6.86185L12.6667 7.72378L14.862 5.52851C15.1223 5.26816 15.5444 5.26816 15.8048 5.52851Z"
                fill="#5E1E5C"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.66673 2.66659C4.56216 2.66659 3.66673 3.56202 3.66673 4.66659C3.66673 5.77115 4.56216 6.66659 5.66673 6.66659C6.7713 6.66659 7.66673 5.77115 7.66673 4.66659C7.66673 3.56202 6.7713 2.66659 5.66673 2.66659ZM2.33339 4.66659C2.33339 2.82564 3.82578 1.33325 5.66673 1.33325C7.50768 1.33325 9.00006 2.82564 9.00006 4.66659C9.00006 6.50753 7.50768 7.99992 5.66673 7.99992C3.82578 7.99992 2.33339 6.50753 2.33339 4.66659Z"
                fill="#5E1E5C"
            />
        </g>
        <defs>
            <clipPath id="clip0_2416_274">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default PersonWithCheckIcon